import React, {Component} from 'react';
import { Select, SelectItem } from 'carbon-components-react';
import PropertyComponent from './PropertyComponent';
import * as midi from '../js/rpl_midi.js';

/*
 * Menu for selecting parameter values.
 *
 * propId: 8192 + parameter ID (send & receive).
 * ccNum: MIDI control change (receive).
 * ccMultiplier: incoming CC values are divided by this, use 128/num_values.
 * fromCCValue: override this function to map CC values to parameter values.
 */
class IndexedParameterSelect extends PropertyComponent {

	constructor(props) {
		super(props);

		this.ccMultiplier = props.ccMultiplier || null;

		this.handleChange = this.handleChange.bind(this);
	}

	render() {
		return (
	  		<Select labelText={this.labelText} value={this.state.value} onChange={this.handleChange} disabled={this.state.disabled}>
			{this.props.children}
			</Select>
		);
	}

	handleChange(event) {
		var newValue = event.target.value;
		this.setState({value: newValue});
		midi.setIndexedParameterValue(this.propId, newValue);
	}

	handleControlChange(ccNum, ccValue) {
		this.setValue(this.fromCCValue(ccValue));
	}

	fromCCValue(ccValue) {
		var value = ccValue;
		if (this.ccMultiplier) {
			value = Math.floor(value / this.ccMultiplier);
		}

		return value;
	}

	setValue(x) {
		this.setState({value: x});
	}
}

class IndexedParameterValue extends React.Component {
	render() {
		return (
		  <SelectItem value={this.props.value} text={this.props.text}/>
		);
	}
}

export { IndexedParameterSelect, IndexedParameterValue };

